import { render, staticRenderFns } from "./LocatorFiltersBrands.vue?vue&type=template&id=40d32e10&"
import script from "./LocatorFiltersBrands.vue?vue&type=script&lang=js&"
export * from "./LocatorFiltersBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports